<template>
  <div class="p-booking">
    <BookingHeader :step="wizardStep" />
    <router-view />
    <BookingProgress
      v-if="selectionStarted"
      @change-step="(step) => (wizardStep = step)" />
  </div>

  <!-- <button
    type="button"
    class="btn btn-dropdown btn-print-state"
    @click="store.printStore">
    Print Store
  </button> -->
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import BookingHeader from '../components/Booking/BookingHeader.vue'
import BookingProgress from '../components/Booking/BookingProgress.vue'
import { useBookingStore } from '../store/BookingStore'
import { getData } from '../../lib/lib'

const bookingData = getData('bookingData')
const store = useBookingStore()
const wizardStep = ref(0)

const selectionStarted = computed(() => {
  return store.bookingProgress.step > 0
})

onMounted(() => {
  store.assignDomData(bookingData)
})

document.addEventListener('login-was-held', (e) => {
  const { accountData } = e.detail
  console.log('accountData', accountData)
  store.setAccountData(accountData)
  store.setPaymentDetails(accountData)
})
</script>

<style scoped lang="scss">
.btn-print-state {
  position: fixed;
  bottom: 10em;
  right: 1em;
  padding: 8px;
  font-size: 0.65em;
  z-index: 10;
}
</style>
